// @flow
import React, {Component} from 'react';
import {
  ScrollView,
  StyleSheet,
  View,
  Platform,
} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import {
  FullButton,
  GradientPage,
  SecondaryFullButton,
  TaxFootnote,
} from '../../../components/common';
import ServiceOptions from '../../../components/options/ServiceOptions';
import PlanSliders from '../../../components/plan/PlanSliders';
import StepperPlanSliders from '../../../components/plan/StepperPlanSliders';
import PlanUniqueOffer from '../../../components/plan/PlanUniqueOffer';

import config from '../../../config';
import formatPeriodicity from '../../../lib/TripicaPeriodicityFormatter';
import FormatService from '../../../lib/format';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';
import {SelectedVoucherItem} from '../../Vouchers/components/SelectedVoucherItem';
import VouchersFrame from '../../Vouchers/components/VouchersFrame';
import LegalBlurb from './components/LegalBlurb';
import SimCardInformation from './components/SimCardInformation';
import * as Navigation from '../../../lib/navigation.js';
import FreeTrialModal from '../../../components/common/FreeTrialModal.js';
import PageTitle from '../../../components/signUp/PageTitle';

class ChoosePlan extends Component<Props> {
  state = {currentStep: 0};
  styles = getStyles();

  componentDidMount() {
    if (this.props.setVoucherDetailsComeFrom) {
      this.props.setVoucherDetailsComeFrom(this.props.orderType ?? '');
    }

    if (this.props.fetchFreeTrial) {
      this.props.fetchFreeTrial();
    }
  }

  componentWillUnmount() {
    if (this.props.setCurrentVoucherDetails) {
      this.props.setCurrentVoucherDetails(null);
    }
  }

  goToCreateAccount = () => {
    this.props.clearChosenPhoneNumber();
    let nextPage = '';
    if (this.props.isLoggedIn) {
      if (config.askPersonalInformationDuringOrderSim) {
        nextPage = 'identityRequirements';
      }
    } else {
      nextPage = 'createAccount';
    }

    Navigation.navigate(nextPage);
    this.props.initNewOffer(null, true);
  };

  onBackButtonPressAndroid = () => !!this.props.route.params?.cannotGoBack;

  onPressSelectedVoucher = () => {
    Navigation.navigate('voucherDetails', {
      voucherDetails: this.props.currentVoucherDetails,
      disabledButton: true,
    });
  };

  isUniqueOffer = () => {
    return (
      this.props.creditableOptions.length === 3 &&
      this.props.creditableOptions[0].length === 1 &&
      this.props.creditableOptions[1].length === 1 &&
      this.props.creditableOptions[2].length === 1
    );
  };

  renderVouchersFrame = (orderType: string) => {
    const isVoucherDisplayableAndNotEmpty =
      this.props.displayVouchersForChoosePlan &&
      !this.props.currentVoucherDetails &&
      this.props.filteredAvailableVouchers &&
      this.props.filteredAvailableVouchers.length > 0;

    const isOrderTypeValid =
      orderType.toLowerCase() === 'signup' ||
      orderType.toLowerCase() === 'subscription';

    if (isVoucherDisplayableAndNotEmpty && isOrderTypeValid) {
      return <VouchersFrame comeFrom="signup" parentScreen="choosePlan" />;
    } else if (isVoucherDisplayableAndNotEmpty) {
      return <VouchersFrame comeFrom={orderType} />;
    }

    return null;
  };

  isModalAllowed = () => {
    // const enabled = I18n.t('promotion.FREE_TRIAL.enabled') ?? 'false';
    // return enabled === 'true';
    return !!this.props.freeTrialActivationBonus?.freeTrial;
  };

  render() {
    const {styles} = this;
    const {
      displayLegalBlurb,
      displayPricesShownAreExclusiveOfTaxMessage,
      displaySimIsAddedInOrder,
      isFreeSimPathAvailable,
      isOfferValid,
      newOfferPeriodicity,
      newOfferPrice,
      orderType,
      comeFrom,
      selectThisPlan,
      currentVoucherDetails,
      displayVouchersForChoosePlan,
    } = this.props;

    return (
      <GradientPage maxWidth={600}>
        <PageTitle
          title={I18n.t('SignUp.ChoosePlan.title')}
        />
        <View style={[styles.pageContainer]}>
          {this.renderVouchersFrame(orderType.toLowerCase())}
          {!config.displayRoamingPlanSliders ? (
            <>
              {this.isUniqueOffer() ? (
                <PlanUniqueOffer
                  withZoneValidity
                  creditableOptions={this.props.creditableOptions}
                  isChangingPlanDuringTurnBackOn
                  orderType={this.props.orderType}
                  isActivation={true}
                />
              ) : (
                <PlanSliders
                  withZoneValidity
                  orderType={orderType}
                  isActivation={true}
                />
              )}
              <ServiceOptions />
            </>
          ) : this.isUniqueOffer() ? (
            <PlanUniqueOffer
              withZoneValidity
              creditableOptions={this.props.creditableOptions}
              isChangingPlanDuringTurnBackOn
              orderType={this.props.orderType}
              isActivation={true}
            />
          ) : (
            <>
              <StepperPlanSliders
                withZoneValidity
                orderType={orderType}
                isUniqueOffer={false}
                currentStep={this.state.currentStep}
                onStepChange={(step) => this.setState({currentStep: step})}
              />
              {this.state.currentStep === 0 && <ServiceOptions />}
            </>
          )}
          {!isFreeSimPathAvailable && displaySimIsAddedInOrder && (
            <SimCardInformation />
          )}
          {displayLegalBlurb && <LegalBlurb />}
        </View>
        <View style={styles.bottomPanel}>
          <View style={styles.newPriceContainer}>
            <Text style={styles.newPriceLabel}>{I18n.t('yourNewPlan')}:</Text>
            <Text style={styles.newPrice}>
              {FormatService.formatCentsToCurrency(newOfferPrice, true)}
              {formatPeriodicity(newOfferPeriodicity)}
            </Text>
          </View>
          {displayPricesShownAreExclusiveOfTaxMessage && <TaxFootnote />}
          {displayVouchersForChoosePlan && currentVoucherDetails ? (
            <SelectedVoucherItem
              selectedVoucher={currentVoucherDetails}
              onPressSelectedVoucher={this.onPressSelectedVoucher}
            />
          ) : null}
          {config.displayRoamingPlanSliders &&
            this.props.hasRoamingOptions &&
            !this.isUniqueOffer() &&
            this.state.currentStep === 0 ? (
            <FullButton
              text={I18n.t('stepper.next')}
              onPress={() => this.setState({currentStep: 1})}
              testID={'choosePlanNextButton'}
            />
          ) : (
            <FullButton
              text={I18n.t('SignUp.ChoosePlan.selectThisPlan')}
              onPress={selectThisPlan}
              disabled={!isOfferValid}
              testID={'choosePlanButton'}
            />
          )}
          {isFreeSimPathAvailable && (
            <SecondaryFullButton
              onPress={this.goToCreateAccount}
              style={styles.secondaryButton}
              text={I18n.t('SignUp.ChoosePlan.freeSimLink')}
              testID={'freeSimButton'}
            />
          )}
        </View>
        {!!this.isModalAllowed() && (
          <FreeTrialModal />
        )}
      </GradientPage>
    );
  }
}

type Props = NavigationScreenProp &
  DispatchProps &
  StateProps &
  FlaggedProps &
  withOrderTypeProps &
  OtherProps;

export type OtherProps = {
  selectThisPlan: () => void,
};

export type DispatchProps = {
  clearChosenPhoneNumber: Function,
  initNewOffer?: Function,
  setVoucherDetailsComeFrom: Function,
  fetchFreeTrial: Function,
};

export type StateProps = {
  newOfferPrice: number,
  newOfferPeriodicity: Object,
  isOfferValid: boolean,
  isLoggedIn: boolean,
  currentVoucherDetails: Object,
  creditableOptions: Object[][],
  hasRoamingOptions: boolean,
};

export type FlaggedProps = {
  isFreeSimPathAvailable: boolean,
  displayPricesShownAreExclusiveOfTaxMessage: boolean,
  displayLegalBlurb: boolean,
  displaySimIsAddedInOrder: boolean,
};

export type withOrderTypeProps = {
  orderType: string,
};

function getStyles() {
  return StyleSheet.create({
    pageContainer: {
      flex: 1,
      width: '100%',
    },
    bottomPanel: {
      marginTop: 15,
      paddingVertical: 13,
      paddingHorizontal: 20,
      width: '100%',
      maxWidth: 600,
      alignSelf: 'center',
      justifyContent: 'center',
      backgroundColor: '#FFFFFF',
      borderTopWidth: 1,
      borderTopColor: theme.bottomPanelBorderColor,
    },
    secondaryButton: {
      marginTop: 8,
    },
    newPriceContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 10,
    },
    newPriceLabel: {
      color: theme.choosePlan.footer.labelColor,
      fontSize: 18,
    },
    newPrice: {
      color: theme.choosePlan.footer.priceColor,
      fontSize: 20,
      fontWeight: 'bold',
    },
  });
}

export default ChoosePlan;
